import React from 'react';

/** The supplied Lentic lockup: vector, transparent background, teal and navy. */
export const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/hKyoiRxLvYpWPxftj89JFp/lentic-logo-horizontal-teal-navy.svg';
type LenticLogoProps = {
  /** Rendered height of the lockup in px. */
  size?: number;
  className?: string;
};
export function LenticLogo({
  size = 34,
  className
}: LenticLogoProps) {
  return <img src={LOGO_SRC} alt="Lentic" style={{
    height: size,
    width: 'auto'
  }} className={['block select-none', className ?? ''].join(' ')} data-id="element-17" data-mp="2cvcwhpe3v90k" />;
}